import { render, staticRenderFns } from "./Cx3CallVaultWizard.vue?vue&type=template&id=8ca73e24&"
import script from "./Cx3CallVaultWizard.vue?vue&type=script&lang=js&"
export * from "./Cx3CallVaultWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports